import * as Constants from '../../../helpers/Constants'

const Styles = {
  container: {
    flexDirection: 'column',
    padding: 15,
    paddingBottom: 0,
    backgroundColor: 'white',
    marginTop: 20,
    display: 'flex',
    width: '90%'
  },
  imageStyle: { width: 40, height: 40 },
  threadPosterStyle: {
    flexDirection: 'column',
    marginLeft: 7,
    display: 'flex'
  },
  threadPosterContainerStyle: {
    flexDirection: 'row',
    marginBottom: 8,
    justifyContent: 'space-between',
    display: 'flex'
  },
  threadPosterHeaderStyle: {
    fontSize: 20,
    margin: 0,
    color: '#3b424d'
  },
  threadPosterTimeAgoStyle: {
    margin: 0,
    fontSize: 13,
    color: '#90949c'
  },
  likesAndCommentsContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex'
  },
  numberOfLikesStyle: {
    color: '#90949c',
    fontSize: 13,
    margin: 0,
    marginLeft: 3
  },
  numberOfCommentsStyle: {
    color: '#90949c',
    fontSize: 13
  },
  likeOrCommentContainerStyle: {
    borderTopWidth: 0.5,
    borderColor: 'rgba(144, 148, 156, 0.3)',
    flexDirection: 'row',
    width: '100%',
    marginTop: 8,
    marginBottom: 4,
    alignItems: 'center',
    height: 40,
    display: 'flex'
  },
  likeOrCommentButtonStyle: {
    width: '50%',
    justifyContent: 'center',
    flexDirection: 'row',
    height: 39,
    alignItems: 'center',
    display: 'flex'
  },
  textStyle: {
    color: '#3b424d',
    fontSize: 14
  },
  commentContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10
  },
  innerCommentContainer: {
    borderRadius: 25,
    width: '95%',
    backgroundColor: Constants.WHITE_LABEL.colors.primary,
    display: 'flex',
    flexDirection: 'column',
    padding: 7,
    paddingLeft: 15,
    paddingRight: 15,
    alignSelf: 'baseline',
    wordBreak: 'break-all'
  },
  informationCommentContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  senderText: {
    color: '#fff',
    fontWeight: 'bold',
    margin: 0,
    marginRight: 4,
    fontSize: 13
  },
  date: {
    margin: 0,
    fontSize: 10,
    color: '#fff'
  },
  comment: {
    color: '#fff',
    margin: 0,
    fontSize: 13
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/containers/FeedItems/styles.js